// extracted by mini-css-extract-plugin
module.exports = {"fixed":"tableHeadSortLabe_fixed__fzNML","tableHeadCell":"tableHeadSortLabe_tableHeadCell__1rppo","stickyHeader":"tableHeadSortLabe_stickyHeader__3fkZQ"};